import { useEffect } from 'react';
import type { EditorSDK } from '../sdk';
import type { EditorSdkEvents } from '../types';

export const useEditorEvent = <T extends keyof EditorSdkEvents>(
  editor: EditorSDK,
  eventName: T,
  callback: (data: EditorSdkEvents[T]) => void
) =>
  useEffect(() => {
    const unsubscribe = editor.subscribe(eventName, callback);
    return () => unsubscribe();
  }, [editor, eventName, callback]);
